<template>
    <div class="module" style="background-color: red">
    </div>
</template>

<script>
    export default {
        name: "Test",
        created: function () {
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            // We listen to the resize event
            window.addEventListener('resize', () => {
                // We execute the same script as before
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            });
        }
    }
</script>

<style>
    body {
        background-color: #333;
    }

    .module {
        height: 100%; /* Use vh as a fallback for browsers that do not support Custom Properties */
        margin: 0 auto;
        max-width: 30%;
    }

    .module__item {
        align-items: center;
        display: flex;
        height: 20%;
        justify-content: center;
    }

    .module__item:nth-child(odd) {
        background-color: #fff;
        color: #F73859;
    }

    .module__item:nth-child(even) {
        background-color: #F73859;
        color: #F1D08A;
    }
</style>
